import { Server } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const HorizontalServerIcon = createLucideIcon(Server);
